import { render, staticRenderFns } from "./materialIcon.vue?vue&type=template&id=4720842c&"
import script from "./materialIcon.vue?vue&type=script&lang=js&"
export * from "./materialIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports